import { render, staticRenderFns } from "./DashboardShipperCs.vue?vue&type=template&id=fced1c54"
import script from "./DashboardShipperCs.vue?vue&type=script&lang=js"
export * from "./DashboardShipperCs.vue?vue&type=script&lang=js"
import style0 from "./DashboardShipperCs.vue?vue&type=style&index=0&id=fced1c54&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports